import { effect, inject, Injector, runInInjectionContext, Signal } from "@angular/core";
import { Context } from "@ag-ui/client";
import { AgentKitService } from "./agent-kit.service";

export interface ConnectAgentContextConfig {
  injector?: Injector;
}

export function connectAgentContext(context: Context | Signal<Context>, config?: ConnectAgentContextConfig) {
  const injector = inject(Injector, { optional: true }) ?? config?.injector;

  if (!injector) {
    throw new Error(
      "Injector not found. You must call connectAgentContext in an injector context or pass an injector in the config",
    );
  }

  runInInjectionContext(injector, () => {
    const agentKit = inject(AgentKitService);

    effect((teardown) => {
      const contextValue = typeof context === "function" ? context() : context;
      const id = agentKit.core.addContext(contextValue);

      teardown(() => {
        agentKit.core.removeContext(id);
      });
    });
  });
}
